import React, { useEffect, useState } from "react";

import type { WebhookHeader } from "@platform/dmv-api";

import ButtonPrimary from "../ButtonPrimary";
import ButtonSecondary from "../ButtonSecondary";
import Modal from "../Modal";

type WebhookHeaderModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSave: (header: WebhookHeader) => void;
};

const inputClassName =
  "w-full rounded border border-gray-300 p-2.5 text-sm placeholder-gray-400 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-black";

const WebhookHeaderModal = ({
  isOpen,
  onClose,
  onSave,
}: WebhookHeaderModalProps) => {
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");

  useEffect(() => {
    if (isOpen) {
      setKey("");
      setValue("");
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({ key, value });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add Header">
      <form onSubmit={handleSubmit} className="flex flex-col gap-y-5">
        <div className="flex flex-col gap-y-2">
          <label className="text-sm font-medium text-gray-700">
            Header Key
          </label>
          <input
            type="text"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="Authorization"
            className={inputClassName}
            required
          />
        </div>

        <div className="flex flex-col gap-y-2">
          <label className="text-sm font-medium text-gray-700">
            Header Value
          </label>
          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Bearer your-token-here"
            className={inputClassName}
            required
          />
        </div>

        <div className="flex justify-end gap-x-3 pt-4 border-t border-gray-200">
          <ButtonSecondary text="Cancel" onClick={onClose} type="button" />
          <ButtonPrimary
            text="Add"
            type="submit"
            icon={undefined}
            className=""
          />
        </div>
      </form>
    </Modal>
  );
};

export default WebhookHeaderModal;
